import http from './http'
var Utils = {
  submitCommond: (data) => http.post(`/interface/bussendemail`, data),
  // submitCommond: (data) => http.post(`/mobileinterface/oldtonew`)
  // 获取分享配置以及追踪记录
  shareConfig: (data) => http.post(`/mobileinterface/shareaward`, data)
}
export default Utils
